 
import React, { useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getToken } from './Configuration';

import SideMenu from "./SideMenu";
import Header from "./Header";
import Menu from "./Menu";
import Footer from "./Footer";
import { getAuthorization } from "./Configuration";
import CryptoService from './Config/action/crypto';
// handle the private routes
function AdminRoute({ component: Component, ...rest }) {

  const [activeNotification, setActiveNotification] = useState(false);

  return (
    <Route
      {...rest}
      render={(props) => {
        // getToken() restores Configuration.USER_ID/USER_NAME/AUTH_TOKEN from
        // localStorage as a side effect. PrivateRoute already calls it, which
        // is why navigating here by clicking a sidebar link (through a
        // PrivateRoute page first) worked. Refreshing the browser while
        // already on an AdminRoute page skipped that call entirely, so
        // Configuration.USER_ID stayed at its unauthenticated default ("0")
        // and every admin page's own loginID-based check correctly refused
        // that id -- "Administrator access required" for an actual admin.
        const authed = !!getToken();
        const isAdmin = authed && CryptoService.decrypt(getAuthorization()).isAdmin;
        if (isAdmin) {
          return (
            <div>
              <Menu></Menu>
              <SideMenu></SideMenu>
              <Component setActiveNotification={setActiveNotification} {...props} />
              <Header activeNotification={activeNotification} setActiveNotification={setActiveNotification}></Header>
            </div>
          );
        }
        return <Redirect to={{ pathname: authed ? '/dashboard' : '/login', state: { from: props.location } }} />;
      }}
    />
  )
}
 
export default AdminRoute;